import Fetch from '@/hooks/fetch';
import { pagingHookConfig } from '@/hooks/paging';
import actions from '../constants';

export default {
  useFetchActiveRequestTask: ({ readStatus }) => Fetch.useFetchDispatch(
    actions.FETCH_ACTIVE_REQUEST_TASK,
    readStatus,
  ),
  useFetchRequestTasks: ({ category }, readStatus, config = pagingHookConfig()) => Fetch.useFetchDispatch(
    actions.FETCH_REQUEST_TASKS,
    readStatus,
    { category },
    config,
  ),
  useFetchRequestTaskViews: ({ category }, readStatus) => Fetch.useFetchDispatch(
    actions.FETCH_REQUEST_TASK_VIEWS,
    readStatus,
    { category },
  ),
};
